export function toLocalIsoDate(value = new Date()) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function isFutureLocalDate(dateString, referenceDate = new Date()) {
  if (!dateString) return false;
  const normalizedDate = String(dateString).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(normalizedDate)) return false;
  return normalizedDate > toLocalIsoDate(referenceDate);
}

